import en from "./en.json";
import uk from "./uk.json";

export const resources = {
	en,
	uk,
};
